import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { UpdateWorkflowSectionDto } from '../dtos/update-workflow-section-dto.interface';
import { WorkflowSectionDto } from '../dtos/workflow-section-dto.interface';

export const WorkflowSectionsActions = createActionGroup({
    source: 'Workflows',
    events: {
        'Load Sections': emptyProps(),
        'Sections Loaded': props<{ response: WorkflowSectionDto[] }>(),
        'Sections Load Failure': props<{ error: HttpErrorResponse }>(),

        'Update Section': props<{ sectionId: string; updateSectionDto: UpdateWorkflowSectionDto }>(),
        'Section Updated': props<{ response: WorkflowSectionDto }>(),
        'Section Update Failure': props<{ error: HttpErrorResponse }>(),
    },
});
